// Iter191 · Página "¿Olvidé mi contraseña?"
// Envía el email y muestra el mismo mensaje aunque el correo no exista.
import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email: email.trim().toLowerCase(),
      });
      setSent(true);
    } catch (err) {
      setError("No se pudo procesar la solicitud. Inténtalo de nuevo en unos segundos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-white to-slate-50 p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
        <div className="bg-gradient-to-br from-[#007934] to-emerald-600 p-6 text-white">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/15 mb-3">
            <Mail size={22} />
          </div>
          <h1 className="text-xl font-bold">¿Olvidaste tu contraseña?</h1>
          <p className="text-sm opacity-85 mt-1">Te enviamos un enlace para restablecerla.</p>
        </div>
        <div className="p-6">
          {sent ? (
            <div data-testid="forgot-sent-msg" className="text-center space-y-4">
              <div className="text-sm text-slate-700">
                Si existe una cuenta con el correo <b>{email}</b>, recibirás en unos instantes un email con un enlace para elegir una nueva contraseña.
              </div>
              <div className="text-xs text-slate-500">El enlace caduca en 1 hora y solo puede usarse una vez.</div>
              <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-[#007934] font-semibold hover:underline">
                <ArrowLeft size={14}/> Volver al login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <label className="block">
                <span className="block text-xs font-semibold text-slate-700 mb-1">Email de la cuenta</span>
                <input
                  type="email" required autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="tu.email@valorizasm.com"
                  className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:border-[#007934] focus:outline-none focus:ring-2 focus:ring-[#007934]/20"
                  data-testid="forgot-email-input"
                />
              </label>
              {error && <div className="text-sm text-rose-600" role="alert">{error}</div>}
              <button
                type="submit" disabled={loading || !email}
                className="w-full bg-[#007934] text-white rounded-lg py-2.5 font-semibold hover:bg-[#006630] transition disabled:opacity-60 flex items-center justify-center gap-2"
                data-testid="forgot-submit-btn"
              >
                {loading ? <Loader2 size={16} className="animate-spin"/> : <Mail size={16}/>}
                {loading ? "Enviando..." : "Enviar enlace"}
              </button>
              <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-700">
                Volver al login
              </Link>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
